import { string } from 'yup';

export const emailSchema = string().email().trim().required();

export const passwordSchema = string().trim().required();
